/**
 * Global Axios configuration — CSRF double-submit cookie pattern.
 *
 * Import this file once (in index.js) so that every subsequent
 * `import axios from 'axios'` automatically includes credentials
 * and the XSRF-TOKEN header.
 */
import axios from 'axios';

// Ensure cookies are sent on every request (httpOnly auth cookies + XSRF-TOKEN).
axios.defaults.withCredentials = true;

/**
 * Read a cookie value by name from `document.cookie`.
 */
function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[2]) : null;
}

/**
 * Request interceptor: on every outgoing request, read the XSRF-TOKEN
 * cookie that the backend sets and attach it as the X-XSRF-TOKEN header.
 * The backend compares the two values to verify the request originated
 * from our own frontend, not a cross-origin attacker.
 */
axios.interceptors.request.use((config) => {
    const token = getCookie('XSRF-TOKEN');
    if (token) {
        config.headers['X-XSRF-TOKEN'] = token;
    }
    return config;
});
